module.exports = __webpack_public_path__ + "img/bgImg4.84c07ccc.png";